import {Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter} from '@angular/core';
import {DialogService} from '@rbaip/ui-component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {Opportunity} from '../../shared/domain/opportunity';
import {AssetPackageDto} from '../../shared/domain/asset-package';
import {ItemSummaryAssetsService} from '../../shared/asset/item-summary-assets.service';
import {ItemSummaryOpportunityService} from '../../shared/opportunity/item-summary-opportunity.service';
import {SALESHUB_CONTRACT_STATUS} from '../../shared/domain/contract';
import {MergePackageComponent} from '../../asset-package/merge-package/merge-package.component';

@Component({
  selector: 'lib-item-summary-opportunity-contract-card',
  templateUrl: './opportunity-contract-card.component.html',
  styleUrls: ['./opportunity-contract-card.component.scss']
})
export class OpportunityContractCardComponent implements OnInit, OnChanges {
  @Input() assetControlGroup: AssetPackageDto;
  @Input() displayDoesCustomerOwesMoney: boolean;
  @Input() displayInOneLine: boolean;
  @Output() mergePackage: EventEmitter<any> = new EventEmitter();
  @Output() contractNumber: EventEmitter<string> = new EventEmitter<string>();
  opportunity: Opportunity;
  opportunityName = '';
  opportunityStage: string = null;
  opportunityType: string;
  opportunityBackground: string;
  opportunityId = 0;
  acgId = 0;
  contractId = 0;
  cardtitleText: string ;
  cardSubTitleText: string;
  stageText: string;
  doesCustomerOweMoney = true;
  rbSalesHubSandboxUrl = '';
  opportunityUrl = '';
  contractUrl = '';
  contractBackground  = 'card-body h-100  background-grey';
  contractCardtitleText = 'card-title text-white';
  contractCardSubTitleText = 'card-subtitle text-white';
  contractDocstatus = 'badge badge-grey';
  contractDocumentStatusName: string;
  salesHubContractId: string = null;
  salesHubContractNumber: string = null;
  contractRecordType = '';
  contractName = 'No Contract exists for this package yet';
  contractState: string;
  contractStateStyle = 'badge badge-grey';


  constructor(private dialogService: DialogService,
              private assetsService: ItemSummaryAssetsService,
              private dialog: MatDialog,
              private opportunityService: ItemSummaryOpportunityService) { }

  ngOnInit() {
    if (!!this.assetControlGroup) {
      this.acgId = this.assetControlGroup.acgId;
    }
  }

  private getSandBoxUrl() {
    this.assetsService.getSandBoxUrl().subscribe( response => {
      this.rbSalesHubSandboxUrl = response.sandBoxUrl;
      this.opportunityUrl = this.rbSalesHubSandboxUrl + '/' + this.opportunity.opportunityId;
      this.contractUrl = this.rbSalesHubSandboxUrl + '/' + this.opportunity.contractId;
      this.contractState = this.opportunity.contractState;
    });

  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.assetControlGroup) {
      if (this.assetControlGroup) {
        this.assetControlGroup.doesCustomerOwesMoney ?  this.doesCustomerOweMoney = false : this.doesCustomerOweMoney = true;
      }
      if (this.assetControlGroup  && this.assetControlGroup.opportunityId ) {
        this.getOpportunityDetails(this.assetControlGroup.opportunityId);
      } else {
        this.opportunityName = 'This Package hasn\'t been assigned to an Opportunity yet!';
        this.getOpportunityStage();
      }
      if (!!this.assetControlGroup) {
        this.acgId = this.assetControlGroup.acgId;
      }
    }
  }

  getOpportunityStage() {
    if (this.opportunityStage) {
      if (this.opportunityStage === 'Confirming Needs' || this.opportunityStage === 'Developing Proposal' || this.opportunityStage === 'Negotiating' || this.opportunityStage === 'Open') {
        this.opportunityBackground = 'card-body h-100  background-orange';
        this.cardtitleText = 'card-title text-white';
        this.cardSubTitleText = 'card-subtitle text-white';
        this.stageText = 'badge badge-orange badge-layout';
      } else if (this.opportunityStage === 'Closed Won' || this.opportunityStage === 'Sold') {
        this.opportunityBackground = 'card-body h-100  background-green';
        this.cardtitleText = 'card-title text-white';
        this.cardSubTitleText = 'card-subtitle text-white';
        this.stageText = 'badge badge-green badge-layout';
      } else if (this.opportunityStage === 'Closed Lost') {
        this.opportunityBackground = 'card-body h-100  background-red';
        this.cardtitleText = 'card-title text-white';
        this.cardSubTitleText = 'card-subtitle text-white';
        this.stageText = 'badge badge-red badge-layout';
      } else if (this.opportunityStage === 'Future' || this.opportunityStage === 'Closed') {
        this.opportunityBackground = 'card-body h-100  background-grey';
        this.cardtitleText = 'card-title text-white';
        this.cardSubTitleText = 'card-subtitle text-white';
        this.stageText = 'badge badge-grey badge-layout';
      } else if (this.opportunityStage === 'Sent to IP for Pricing' || this.opportunityStage === 'Pricing in Progress' || this.opportunityStage === 'Sent for Pricing') {
        this.opportunityBackground = 'card-body h-100 background-darkBlue';
        this.cardtitleText = 'card-title text-white';
        this.cardSubTitleText = 'card-subtitle text-white';
        this.stageText = 'badge badge-darkBlue badge-layout';
      } else if (this.opportunityStage === 'Pricing Complete') {
        this.cardtitleText = 'card-title text-white';
        this.cardSubTitleText = 'card-subtitle text-white';
        this.stageText = 'badge badge-lightBlue badge-layout';
        this.opportunityBackground = 'card-body h-100 background-lightBlue';
      }
    } else {
      this.opportunityBackground = 'card-body h-100  background-grey';
      this.cardtitleText = 'card-title text-white';
      this.cardSubTitleText = 'card-subtitle text-white';
      this.stageText = 'badge badge-grey badge-layout';
    }
  }

  public toggleDoesCustomerOwes(isCustomerOwes) {
    this.dialogService.showProgress();
    this.assetsService.updateDoesCustomerOwesMoney(this.assetControlGroup.acgId, isCustomerOwes)
      .subscribe(response => {
        if (response && response.error) {
          this.dialogService.showMessage(response.getErrorMessage());
        } else {
          if (isCustomerOwes) {
            this.dialogService.showMessage('Customer Owes Money set to "Yes"');
          } else {
            this.dialogService.showMessage('Customer Owes Money set to "No"');
          }
        }
        this.dialogService.hideProgress();
        this.doesCustomerOweMoney = response as boolean;
      });
  }

  getContractDocStatus() {
    if (this.opportunity.contractDocumentStatus) {
      if (this.opportunity.contractDocumentStatus === 'Not Sent') {
        this.contractBackground = 'card-body h-100  background-yellow';
        this.contractCardtitleText = 'card-title text-white';
        this.contractCardSubTitleText = 'card-subtitle text-white';
        this.contractDocstatus = 'badge badge-docstatus  badge-yellow';
      } else if (this.opportunity.contractDocumentStatus === 'Sent' || this.opportunity.contractDocumentStatus === 'Delivered') {
        this.contractBackground = 'card-body h-100  background-orange';
        this.contractCardtitleText = 'card-title text-white';
        this.contractCardSubTitleText = 'card-subtitle text-white';
        this.contractDocstatus = 'badge badge-docstatus  badge-orange';
      } else if (this.opportunity.contractDocumentStatus === 'Completed') {
        this.contractBackground = 'card-body h-100  background-green';
        this.contractCardtitleText = 'card-title text-white';
        this.contractCardSubTitleText = 'card-subtitle text-white';
        this.contractDocstatus = 'badge badge-docstatus  badge-green';
      } else if (this.opportunity.contractDocumentStatus === 'Declined' || this.opportunity.contractDocumentStatus === 'Voided') {
        this.contractBackground = 'card-body h-100  background-red';
        this.contractCardtitleText = 'card-title text-white';
        this.contractCardSubTitleText = 'card-subtitle text-white';
        this.contractDocstatus = 'badge badge-docstatus  badge-red';
    } else {
        this.contractBackground = 'card-body h-100  background-grey';
        this.contractCardtitleText = 'card-title text-white';
        this.contractCardSubTitleText = 'card-subtitle text-white';
        this.contractDocstatus = 'badge badge-docstatus  badge-grey';
      }
    } else {
      this.contractDocstatus = 'badge badge-grey';
    }
}

  getContractStateStyle() {
    if ( this.opportunity.contractState ) {
      if (this.opportunity.contractState === SALESHUB_CONTRACT_STATUS.inProgress) {
        this.contractStateStyle = 'badge badge-csinprogress';
      } else if (this.opportunity.contractState === SALESHUB_CONTRACT_STATUS.readyForSale) {
        this.contractStateStyle = 'badge badge-csinready';
      } else if (this.opportunity.contractState === SALESHUB_CONTRACT_STATUS.pendingFinalized) {
        this.contractStateStyle = 'badge badge-csinpending';
      } else if (this.opportunity.contractState === SALESHUB_CONTRACT_STATUS.finalized) {
        this.contractStateStyle = 'badge badge-csinfinalized';
      } else if (this.opportunity.contractState === SALESHUB_CONTRACT_STATUS.cancelled) {
        this.contractStateStyle = 'badge badge-csincancelled';
      } else {
        this.contractStateStyle = 'badge badge-csothers';
      }
    } else {
      this.contractStateStyle = 'badge badge-grey';
    }
  }

  getOpportunityDetails(opportunityId: number) {
    if (opportunityId) {
      this.opportunityService.getOpportunityDetails(opportunityId).subscribe(
        opportunity => {
          this.opportunity = opportunity;
          this.opportunityName = this.opportunity.opportunityName;
          this.opportunityId = this.opportunity.ipOpportunityId;
          this.opportunityStage = this.opportunity.opportunityStage;
          this.opportunityType = this.opportunity.opportunityRecordType;
          this.acgId = this.opportunity.acgId;
          this.getOpportunityStage();
          this.getSandBoxUrl();
          this.getContractDocStatus();
          this.getContractStateStyle();
          this.contractDocumentStatusName = this.opportunity.contractDocumentStatus;
          this.salesHubContractId = this.opportunity.contractId;
          this.salesHubContractNumber = this.opportunity.contractNumber;
          this.contractState = this.opportunity.contractState;
          if ( this.opportunity.contractNumber ) {
            this.contractName = this.opportunity.contractNumber;
            this.contractNumber.emit( this.opportunity.contractNumber );
          } else {
            this.contractName = 'No Contract exists for this package yet';
          }
          this.contractRecordType = this.opportunity.contractRecordType;
          this.opportunityService.selectedOpportunityChanged.next(opportunity);
        });
    }
  }

  mergePackageFunc() {
    this.showMergePackage(this.assetControlGroup)
      .afterClosed()
      .subscribe(newlyCreatedACG => {
        // to-do after overlay closed
        this.mergePackage.emit(null); // emit event here
      });
  }

  showMergePackage(acg: AssetPackageDto): MatDialogRef<MergePackageComponent> {
    return this.dialog
      .open(MergePackageComponent, {
        panelClass: 'mat-panel--default',
        autoFocus : false,
        data: {
          acg
        }
      });
  }

  openContractInMars():void
  {
    let url =  '/jsp/sellercontract/view-contract-v2.jsp?contractId='+this.opportunity.sellerContractId;
    window.open(url, '_blank');
  }
}
